import React from "react";
import { NavLink } from "react-router-dom";
import {
  ADMIN_ACCOUNT_PATH,
  USER_HOME_PATH,
  USER_ACCOUNT_PATH,
  ADMIN_RESTAURANTS_PATH,
  RECEPTIONIST_ACCOUNT_PATH,
} from "../../constants/paths";
import { useSelector } from "react-redux";
import { isLoaded, isEmpty } from "react-redux-firebase";

const SignedInLinks = ({ user }) => {
  const profile = useSelector(({ firebase }) => firebase.profile);

  return isLoaded(profile) && !isEmpty(profile) && !profile.isAdmin ? (
    <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
      <div className="text-sm lg:flex-grow"></div>
      <div>
        {!profile?.isReceptionist ? (
          <NavLink
            to={USER_HOME_PATH}
            activeClassName="active"
            exact
            className="block mt-4 lg:inline-block lg:mt-0 text-gray-700 font-medium hover:text-gray-900 mr-4"
          >
            Restaurante
          </NavLink>
        ) : null}
        <NavLink
          to={
            !profile?.isReceptionist
              ? USER_ACCOUNT_PATH
              : RECEPTIONIST_ACCOUNT_PATH
          }
          activeClassName="active"
          exact
          className="block mt-4 lg:inline-block lg:mt-0 text-gray-700 font-medium hover:text-gray-900"
        >
          Mi perfil
        </NavLink>
      </div>
    </div>
  ) : (
    <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
      {" "}
      <div className="text-sm lg:flex-grow"></div>
      {/* <NavLink
        to={ADMIN_RESTAURANTS_PATH}
        activeClassName="active"
        exact
        className="block mt-4 lg:inline-block lg:mt-0 text-gray-700 font-medium font-m hover:text-gray-900 mr-4"
      >
        Restaurantes
      </NavLink> */}
      <NavLink
        to={ADMIN_ACCOUNT_PATH}
        activeClassName="active"
        exact
        className="block mt-4 lg:inline-block lg:mt-0 text-gray-700 font-medium hover:text-gray-900"
      >
        Mi perfil
      </NavLink>
    </div>
  );
};

export default SignedInLinks;
